import React from "react";
import { ReportConfigurationContainer } from "./style";
import { useReport } from "../../context/ReportContext";
import { SelectedQuestion } from "./components/SelectedQuestion"; 
import { InitialSetup } from "./components/InitialSetup";

export const ReportConfiguration = () => {

  const { selectedQuestion } = useReport();

  return (
    <ReportConfigurationContainer>
      {selectedQuestion.enunciado === "Configurar dados do relatório"
        ? <InitialSetup />
        : <SelectedQuestion selectedQuestion={selectedQuestion} />
      }
    </ReportConfigurationContainer>
  )
}